// 📄 components/StepHesErpParams.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { HesErpFormData } from '../../../../../services/commerce/integrationService';

interface StepHesErpParamsProps {
  sesResponseEnabled: boolean;
  onChange: (field: keyof HesErpFormData, value: any) => void;
}

export function StepHesErpParams({ sesResponseEnabled, onChange }: StepHesErpParamsProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">SPRO</span>
          <span>Integration with Other SAP Components → SAP Ariba Cloud Integration Gateway → Application-Specific Settings → Service Entry Sheet Response → Maintain Parameters</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Maintain Parameters (Habilitar Respuesta)</h3>
        <p className="text-sm text-gray-400">
          Habilita el envío de la respuesta de estado de la HES creada/modificada en el ERP hacia SAP Ariba.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 flex items-center justify-between gap-4">
        <div>
          <label className="block text-sm font-medium text-white">Parámetro <code className="bg-black/30 px-1 rounded font-mono text-blue-400">SES_RESPONSE_ENABLED</code></label>
          <p className="text-xs text-gray-400 mt-0.5">Valor bajo (Low) requerido: <code className="bg-black/30 px-1 rounded font-mono">X</code></p>
        </div>
        <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
          <input type="checkbox" checked={sesResponseEnabled || false} onChange={(e) => onChange('sesResponseEnabled', e.target.checked)} className="sr-only peer" />
          <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
        </label>
      </div>

      <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 text-blue-400 flex gap-3 text-sm">
        <AlertCircle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Dependencia con el Output Type</p>
          <p className="text-xs text-blue-400/80 mt-0.5">
            Este parámetro solo tiene efecto si el output type del paso anterior ya está correctamente asignado al procedimiento de mensajes de la aplicación ES.
          </p>
        </div>
      </div>
    </div>
  );
}
